import { Component, OnInit } from '@angular/core';
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {HintManagerService} from "../../services/hintManager/hint-manager.service";

@Component({
  selector: 'app-drawing-hint',
  templateUrl: './drawing-hint.component.html',
  styleUrls: ['./drawing-hint.component.scss']
})
export class DrawingHintComponent implements OnInit {

  public hint: string = null;
  public defaultToolDrawingHintObject = window['FIGURES_DRAWING_HINT_DEFAULT'];

  constructor(private view: CesiumAdapterService, private hintManager: HintManagerService) {
    this.view.currentToolSubject.subscribe((tool) => {
      if (tool) {
        this.hintManager.isTimeoutHint = false;
        if (tool.hasOwnProperty('drawing_hint') && tool.drawing_hint && tool.drawing_hint.length > 0) {
          this.hintManager.hintText = tool.drawing_hint;
        } else {
          this.hintManager.hintText = this.getDefaultDrawingHint(tool);
        }
      } else {
        this.hint = null;
      }
    });

    this.hintManager.hintText.subscribe((hintText)=>{
      this.hint = hintText;
    })
  }

  private getDefaultDrawingHint(tool){
    let type = tool.type;
    let template = this.defaultToolDrawingHintObject[type];

    return this.defaultToolDrawingHintObject && template
    ? template.replace(/\[TOOL_NAME\]/g, tool.name)
    : null;
  }

  public getTextColor(): string {
    return this.hintManager.textColor;
  }

  ngOnInit() {
  }

}
